import React from 'react';
import { useGuest } from '../contexts/GuestContext';
import './VenueBadge.scss';

export const VenueBadge: React.FC = () => {
  const { guestType } = useGuest();

  if (guestType !== 'farmhouse') {
    return null;
  }

  return (
    <div className="venue-badge">
      <div className="venue-badge__coin">
        <div className="venue-badge__inner">
          <div className="venue-badge__text">
            <span className="venue-badge__line1">Staying</span>
            <span className="venue-badge__line2">at Venue</span>
          </div>
        </div>
      </div>
    </div>
  );
};
